// extracted by mini-css-extract-plugin
export default {"pillsWrapper":"FilterPills_pillsWrapper__oRHIW","pill":"FilterPills_pill__AraQV","remove":"FilterPills_remove__SK0LH"};